import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Atoms/Buttons/ColorButtons.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Atoms/FormElements/SearchForm.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Atoms/FormElements/SearchFormGlobal.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Atoms/inputText.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ilias/Github/talnet.co/src/components/Molecules/HeroVideo.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ilias/Github/talnet.co/src/components/Organisms/Cards/BusinessCard.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Organisms/Cards/Chat.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ilias/Github/talnet.co/src/components/Organisms/Cards/FeaturedEntityCard.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Organisms/Cards/SpecializationsParentCard.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Organisms/FAQ.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ilias/Github/talnet.co/src/components/Organisms/SocialFeed.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/contexts/AppProviderContext.js");
